import "animate.css";
// import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

// import { useSelector } from "react-redux";

import "./App.css";
import Header from "./pages/Header";
import Home from "./pages/Home";
import Ecosystem from "./pages/Ecosystem";
import ScrollToTop from "./pages/ScrollToTop";
import Footer from "./pages/Footer";
// import storage from "./utils/storage";

export const wheelUse = () => {
  // document.removeEventListener("wheel", preventScroll);
  document.body.style.overflow = "auto";
  document.body.style.marginRight = "0";
  const element = document.querySelector(".header");
  element.style.setProperty("width", "100%");
};
export const wheelDisUse = () => {
  // document.addEventListener("wheel", preventScroll, { passive: false });
  document.body.style.overflow = "hidden";
  document.body.style.marginRight = "6px";
  const element = document.querySelector(".header");
  element.style.setProperty("width", "calc(100% - 6px)");
};
function App() {
  return (
    <div className="App" id="app">
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ecosystem" element={<Ecosystem />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
